(function (scope) {
  'use strict';
  const parse = (value, fallback) => { try { const result = JSON.parse(value); return result == null ? fallback : result; } catch { return fallback; } };
  const array = value => { const result = parse(value, []); return Array.isArray(result) ? result : []; };
  const minimumFor = () => 25;
  const signature = locations => JSON.stringify(locations.map(location => ({placement:String(location.placement || ''),method:String(location.method || ''),puff:location.puff === true})).sort((a,b) => a.placement.localeCompare(b.placement) || a.method.localeCompare(b.method)));
  function compatible(model, location) {
    if (!['embroidery','transfer','silicone'].includes(location.method)) return false;
    if (!model?.resolved || model.methods?.[location.method] !== true || (location.puff && model.methods.puff !== true)) return false;
    return array(model.placementsRaw).some(placement => placement.id === location.placement && Array.isArray(placement.methods) && placement.methods.includes(location.method) && (!location.puff || placement.puff === true));
  }
  const rules = {parse,array,minimumFor,signature,compatible};
  if (typeof module === 'object' && module.exports) module.exports = rules;
  else scope.WavesHeadwearRules = rules;
})(typeof window === 'undefined' ? {} : window);
